var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-ciec-loading is-flex is-centered" },
    [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/ciec-loading.svg"),
          alt: "loading ciec illustration"
        }
      }),
      _c("h1", { staticClass: "title is-2 has-text-primary" }, [
        _vm._v("\n    Validando CIEC\n  ")
      ]),
      _c("h2", { staticClass: "title is-4 has-text-primary" }, [
        _vm._v("\n    Esto puede durar varios segundos...\n  ")
      ]),
      _c("h2", { staticClass: "title is-4 has-text-primary" }, [
        _vm._v(
          "\n    Puedes seguir ocupando la plataforma mientras se valida la CIEC.\n  "
        )
      ]),
      _c("b-loading", { attrs: { "is-full-page": false, active: "" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }